import {
  GET_SERVICE_LOCATION_TYPE,
  GET_SERVICE_LOCATION_TYPE_FAILURE,
  GET_SERVICE_LOCATION_TYPE_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getServiceLocationTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICE_LOCATION_TYPE:
      return { ...state, loading: true };
    case GET_SERVICE_LOCATION_TYPE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_SERVICE_LOCATION_TYPE_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getServiceLocationTypeReducer;
